import { render, staticRenderFns } from "./AttachMentList.vue?vue&type=template&id=5643e156"
import script from "./AttachMentList.vue?vue&type=script&lang=js"
export * from "./AttachMentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports